import { createContext, useContext } from 'react';

/**
 * True inside any <Modal>. `Button` reads it and draws the Portal pill instead of the
 * bordered square, so every modal in the app changed shape in one pass (Oct 26 2026)
 * without touching the callers. Lives in its own file because Modal imports Button.
 */
export const ModalContext = createContext(false);
export const useInModal = () => useContext(ModalContext);

/** The field inside a modal: a soft grey well, no border, a black focus ring. */
export const MODAL_FIELD = 'w-full rounded-2xl border-0 bg-[#F2F2F2] px-4 py-3 font-mono text-sm text-black outline-none placeholder:text-[#9CA3AF] focus:ring-2 focus:ring-black';
/** A grouped block inside a modal — a breakdown, a quoted message, the card form. */
export const MODAL_WELL = 'rounded-2xl bg-[#F5F5F5] p-4';
/** An error the person has to read before the buttons: a red band, never a red line under them. */
export const MODAL_ERROR = 'rounded-2xl bg-[#FEE2E2] px-4 py-3 font-mono text-[12px] leading-[1.55] text-[#B91C1C]';
/** The small label over a field. */
export const MODAL_LABEL = 'mb-1.5 block font-mono text-[10px] font-bold uppercase tracking-[0.14em] text-[#6B7280]';
/** A quiet line of explanation. */
export const MODAL_NOTE = 'font-mono text-[11px] leading-[1.6] text-[#6B7280]';

/** A chip in a choice grid (`on` fills it black). */
export const modalChoice = (on) =>
  `inline-flex min-h-[40px] items-center justify-center rounded-full px-4 py-2 text-center font-mono text-[11px] font-bold uppercase tracking-[0.12em] transition-colors duration-200 disabled:opacity-50 ${
    on ? 'bg-black text-white' : 'bg-[#F2F2F2] text-black hover:bg-black hover:text-white'
  }`;
/** A row-sized choice (a tier, a town). */
export const modalRow = (on) =>
  `w-full rounded-2xl p-4 text-left transition-colors duration-200 ${
    on ? 'bg-black text-white' : 'bg-[#F5F5F5] text-black hover:bg-[#E9E9E9]'
  }`;
